export default {
    lang: 'en',
    name: 'Count Novel',
    email: 'cy250827@gmail.com',
    fbPixel: {
        1: '1438847163760449',
    },
    adx: {
        1: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_t2',
    },
    ga4: {
        id: 'G-HVDMNM67J9'
    },
    adConfig: {
        default: {
            // 关闭遮罩时间
            closeMaskTime: 20000,
            // 倒计时时间
            time: 400,
            // 20s 计数
            interTime: 20,
            // 是否可以点击穿透
            // 点击广告上线
            clickMax: 20,
        }
    },
    content:{
        1: {
            split: '\n\n',
            textNum: 300,
            p: 3,
        },
    },
    pixelReport: {
        default: {
            chapter: new Set([1, 3, 5, 10, 20, 30]),
            rate: 0.6
        }
    }
}